import { lazy } from 'react';
import Loadable from '../components/Loadable';
import MainLayout from '../layout';
import { Navigate } from 'react-router';
import SidebarRoutes from './SidebarRoutes';
import ProtectedRoute from './ProtectedRoute';

const Home = Loadable(lazy(() => import('../pages/home/Home')));
const KitchenOrderTicket = Loadable(lazy(() => import('../pages/kot/KitchenOrderTicket')));
const BoardView = Loadable(lazy(() => import('../pages/projectGovernance/boardTransactions/Stages')));
const WorkflowDesigner = Loadable(lazy(() => import('../pages/crmModule/Workflowdesigner')));
const Formbuilder = Loadable(lazy(() => import('../pages/crmModule/Formbuilder')));
const AddWorkItem = Loadable(lazy(() => import('../pages/crmModule/AddWorkitem')));
const EditWorkItem = Loadable(lazy(() => import('../pages/crmModule/EditWorkitem')));
const EditFormBuilder = Loadable(lazy(() => import('../pages/crmModule/Formeditor')));
const ForgotPassword = Loadable(lazy(() => import('../pages/resetpassword/ForgotPassword')));

const RedirectRoot = {
  path: '/',
  element: <Navigate to="/login" />
};

const MainRoutes = {
  path: '/*',
  element: (
    <ProtectedRoute>
      <MainLayout />
    </ProtectedRoute>
  ),
  children: [
    { path: 'home', element: <Home /> },
    { path: 'kitchenorderticket', element: <KitchenOrderTicket /> },
    { path: 'board/stage', element: <BoardView /> },
    { path: 'workflow/designer', element: <WorkflowDesigner /> },
    { path: 'workflow/formbuilder', element: <Formbuilder /> },
    { path: 'workitem/add', element: <AddWorkItem /> },
    { path: 'workitem/edit', element: <EditWorkItem /> },
    { path: 'workflow/formeditor', element: <EditFormBuilder /> },
    { path: 'forgotpassword', element: <ForgotPassword /> },
    ...SidebarRoutes
  ]
};

export default [RedirectRoot, MainRoutes];
